/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VisitorTag
 */
export interface VisitorTag {
    /**
     * 
     * @type {string}
     * @memberof VisitorTag
     */
    readonly tagId: string;
}

export function VisitorTagFromJSON(json: any): VisitorTag {
    return VisitorTagFromJSONTyped(json, false);
}

export function VisitorTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitorTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tagId': json['tagId'],
    };
}

export function VisitorTagToJSON(value?: VisitorTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


